import axios from 'axios'
const API_URL = process.env.VUE_APP_API_URL;

export function getLogsTypes() {

    var self = this;

    var config = {
        headers: {
            token: localStorage.getItem('token')
        }
    }
   return new Promise((resolve, reject) => {
        axios.get(API_URL + "/restfull/emsweb/listalogsregex", config).then(resposta => {
            if (resposta.data.Error)
                reject("Erro interno do servidor.");
            else {
                resolve(resposta.data.Rows)
            }
        })
    })
}